import React, { Fragment, useState, useContext, useCallback } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";
import debounce from "lodash.debounce";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  Grid,
  DialogActions,
  DialogContent,
  Dialog,
  Slide,
  Snackbar,
  TextField,
  Alert,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";

import LoadPrefixes from "components/services/LoadPrefixes";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function EditClientAdmin(props) {
  const classes = useStyles();

  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [dateBirthClient, setDateBirthClient] = useState(
    dayjs(props.id.row.datebirth)
  );
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    nameClient1: props.id.row.name1,
    nameClient2: props.id.row.name2,
    lastNameClient1: props.id.row.lastName1,
    lastNameClient2: props.id.row.lastName2,
    emailClient: props.id.row.email,
    documentIdClient: props.id.row.documentId,
    dateBirthClient: dayjs(props.id.row.datebirth).format("YYYY-MM-DD"),
    phoneClient: props.id.row.phone,
    prefix: props.id.row.prefix,
    prefixData: props.id.row.prefix,
    errorPrefix: false,
    errorNameClient1: false,
    errorLastNameClient1: false,
    errorDocumentIdClient: false,
    errorEmailClient: false,
    errorDateBirthClient: false,
    errorPhoneClient: false,
  });

  const handleChange = useCallback((prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
    }));

    // Solo usar debounce para realizar validaciones u otros efectos secundarios
    debounceValidation(prop, value);
  }, []);

  const debounceValidation = useCallback(
    debounce((prop, value) => {
      setValues((prevValues) => ({
        ...prevValues,
        errorNameClient1: false,
        errorLastNameClient1: false,
        errorDocumentIdClient: false,
        errorEmailClient: false,
        errorDateBirthClient: false,
        errorPhoneClient: false,
      }));

      setAlert((prevAlert) => ({
        ...prevAlert,
        openAlert: false,
      }));
    }, 10),
    []
  );

  const changePrefix = (data) => {
    setValues({
      ...values,
      prefix: data !== null ? data : null,
      prefixData: data !== null ? data : null,
      errorPrefix: false,
    });

    setAlert({
      ...alert,
      openAlert: false,
    });
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleDateBirthChange = (data) => {
    const formattedDate = dayjs(data).format("YYYY-MM-DD");

    setValues({
      ...values,
      dateBirthClient: formattedDate,
      errorDateBirthClient: false,
    });

    setDateBirthClient(data);
  };

  const submitForm = async () => {
    setError(false);

    const validations = {
      nameClient1: {
        value: values.nameClient1,
        message: "Agregue un nombre.",
      },
      lastNameClient1: {
        value: values.lastNameClient1,
        message: "Agregue un apellido.",
      },
      documentIdClient: {
        value: values.documentIdClient,
        message: "Agregue un documento de identidad.",
      },
      dateBirthClient: {
        value: values.dateBirthClient,
        message: "Agregue la fecha de nacimiento.",
      },
      emailClient: {
        value: values.emailClient,
        message: "El campo email es obligatorio.",
      },
    };

    for (const [key, { value, message }] of Object.entries(validations)) {
      if (value.length === 0) {
        setValues((prev) => ({
          ...prev,
          [`error${key.charAt(0).toUpperCase() + key.slice(1)}`]: true,
        }));
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "error",
          mensaje: message,
        });
        return; // Salir si hay un error
      }
    }

    const data = {
      name1: values.nameClient1,
      name2: values.nameClient2,
      lastname1: values.lastNameClient1,
      lastname2: values.lastNameClient2,
      allNames: `${values.nameClient1} ${values.nameClient2} ${values.lastNameClient1} ${values.lastNameClient2}`,
      documentId: values.documentIdClient,
      datebirth: values.dateBirthClient,
      email: values.emailClient,
      phone: values.phoneClient,
      prefix: JSON.stringify(values.prefix),
    };

    try {
      const response = await axios.put(
        `${urlServices}clients/${props.id.row.id}`,
        data,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        props.callBackRefresh();
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "success",
          mensaje: "Registro con éxito.",
        });
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    }
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };
  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
                <div className={classes.titleCardFilter}>Editar</div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="nameClient1"
                  value={values.nameClient1}
                  error={values.errorNameClient1}
                  onChange={(event) =>
                    handleChange("nameClient1", event.target.value)
                  }
                  fullWidth
                  required
                  label="Primer nombre"
                  margin="dense"
                  autoComplete="off"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="nameClient2"
                  value={values.nameClient2}
                  onChange={(event) =>
                    handleChange("nameClient2", event.target.value)
                  }
                  fullWidth
                  label="Segundo nombre"
                  margin="dense"
                  autoComplete="off"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="lastNameClient1"
                  value={values.lastNameClient1}
                  error={values.errorLastNameClient1}
                  onChange={(event) =>
                    handleChange("lastNameClient1", event.target.value)
                  }
                  fullWidth
                  required
                  label="Primer apellido"
                  margin="dense"
                  autoComplete="off"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="lastNameClient2"
                  value={values.lastNameClient2}
                  onChange={(event) =>
                    handleChange("lastNameClient2", event.target.value)
                  }
                  fullWidth
                  label="Segundo apellido"
                  margin="dense"
                  autoComplete="off"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="emailClient"
                  value={values.emailClient}
                  error={values.errorEmailClient}
                  onChange={(event) =>
                    handleChange("emailClient", event.target.value)
                  }
                  fullWidth
                  required
                  label="Correo electrónico"
                  margin="dense"
                  autoComplete="off"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="documentIdClient"
                  value={values.documentIdClient}
                  error={values.errorDocumentIdClient}
                  onChange={(event) =>
                    handleChange("documentIdClient", event.target.value)
                  }
                  fullWidth
                  required
                  label="Nro. de documento"
                  margin="dense"
                  variant="outlined"
                  autoComplete="off"
                  inputProps={{
                    style: {
                      textAlign: "left",
                    },
                    maxLength: 13,
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  size="small"
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <LoadPrefixes
                  value={values.prefixData}
                  refresh={changePrefix}
                  error={values.errorPrefix}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <TextField
                  name="phoneClient"
                  value={values.phoneClient}
                  error={values.errorPhoneClient}
                  onChange={(event) =>
                    handleChange("phoneClient", event.target.value)
                  }
                  fullWidth
                  required
                  label="Teléfono"
                  margin="dense"
                  variant="outlined"
                  autoComplete="off"
                  inputProps={{
                    style: {
                      textAlign: "left",
                    },
                    maxLength: 13,
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      name="dateBirthClient"
                      label="Fecha de nacimiento"
                      value={dateBirthClient}
                      onChange={(newValue) => handleDateBirthChange(newValue)}
                      format="DD/MM/YYYY"
                      sx={{
                        "& .MuiButtonBase-root": {
                          color: "#333",
                        },
                        width: "100%",
                        background: "#FFFFFF",
                      }}
                      slotProps={{
                        textField: {
                          // helperText: "DD/MM/YYYY",
                          error: values.errorDateBirthClient,
                          required: true,
                          size: "small",
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12}>
                <br></br>
                <center>
                  <ButtonStyle0 type="submit" onClick={submitForm}>
                    Guardar
                  </ButtonStyle0>
                </center>
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
